import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import Counter from "utils/Counter";

function AlertSnoozeModal(props) {
	const [show, setShow] = useState(false);
	const [count, setCount] = useState(7);
	const [snoozed, setSnooze] = useState(false);
	const handleClose = () => setShow(false);
	const handleShow = () => setShow(true);
	const snoozeSrc = require("images/icons/snooze-icon.png");
	let scriptName = props.alert.script_name ? (props.alert.script_name
		.split("_")
		.map((a) => {
			return a.charAt(0).toUpperCase() + a.substring(1);
		})
		.join(" ")) : "";

	const increment = () => {
		setCount((prevCount) => count + 1);
	};

	const decrement = () => {
		if (count > 1) {
			setCount((prevCount) => count - 1);
		}
	};

	const snoozeAlert = () => {
		setShow(false);
		setSnooze(true);
		props.snoozeAlert(props.alert.id, count, props.alert.script_name);
	};

	return (
		<>
			<Button
				variant="info"
				className="mx-1 d-inline-block"
				onClick={handleShow}
				disabled={snoozed}
			>
				<img src={`/datapulse${snoozeSrc}`} className="snooze-icon" />
				{props.showBtnText && <>{snoozed ? "Snoozed" : "Snooze"}</>}
			</Button>

			<Modal show={show} onHide={handleClose} className="snooze-alert-modal">
				<Modal.Header closeButton>
					<Modal.Title>Snooze Alert</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					{`Snooze ${scriptName} for:`}
					<Counter count={count} increment={increment} decrement={decrement} />
				</Modal.Body>
				<Modal.Footer>
					<Button style={{ backgroundColor: "#A3A3A3" }} onClick={handleClose}>
						Cancel
					</Button>
					<Button variant="info" onClick={snoozeAlert}>
						Snooze
					</Button>
				</Modal.Footer>
			</Modal>
		</>
	);
}

export default AlertSnoozeModal;
